import { render, staticRenderFns } from "./CardHeaderFooter.vue?vue&type=template&id=65df15e8"
import script from "./CardHeaderFooter.vue?vue&type=script&lang=js"
export * from "./CardHeaderFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports